import React from "react";
import { Subscription } from "rxjs";

import { Route, Routes, BrowserRouter } from "react-router-dom";
import { ReactNotifications, Store } from "react-notifications-component";

import { format } from "date-fns";
import { Box } from "@mui/material";

import { Login } from "./pages/Login";
import { Mosaic } from "./pages/Mosaic";
import { SoftwareLogs } from "./pages/SoftwareLogs";
import { Settings } from "./pages/Settings";
import { NetworkError } from "./pages/NetworkError";
import { Logout } from "./pages/Logout";

import { AcrAppBar } from "./components/Header/AcrAppBar";
import { Footer } from "./components/Footer/Footer";
import { Notification } from "./components/Notification";

import { acrAPI } from "./utils/api";
import { PrivateRoute } from "./components/PrivateRoute";
import { translate } from "i18n";
import { License } from "models/LicenseModel";
import ChannelDetail from "pages/ChannelDetail";

export const LICENSE_STATUS = {
  OK: "ok",
  WARNING: "warning",
  ERROR: "error",
};

export class ACRMonitor extends React.Component {
  public state = { licenseNotif: false };
  private licenseInterval = 0;
  private statusInterval = 0;

  private subscribtions: Subscription = new Subscription();

  public constructor(props: any) {
    super(props);
    this.initLicenseStatusTimer();
    this.initStatusTimer();
  }
  public componentDidMount(): void {
    this.subscribtions.add(acrAPI.licenseSubject.subscribe(() => this.notifyLicenseStatus));
  }
  public componentWillUnmount(): void {
    this.subscribtions.unsubscribe();
  }

  private async initLicenseStatusTimer(): Promise<void> {
    this.licenseInterval = 86400000;
    try {
      await acrAPI.getLicenseStatus();
    } catch (e: any) {
      console.log(`Error while getting license (init): ${e?.status} (${e?.statusText})`);
      this.licenseInterval = 4000;
    }
    this.triggerLicenseStatusCustomInterval();
  }

  private triggerLicenseStatusCustomInterval(): void {
    setTimeout(async () => {
      try {
        await acrAPI.getLicenseStatus();
      } catch (e: any) {
        console.log(`Error while getting license : ${e?.status} (${e?.statusText})`);
      }
      this.triggerLicenseStatusCustomInterval();
    }, this.licenseInterval);
  }

  private async initStatusTimer(): Promise<void> {
    this.statusInterval = 20000;
    try {
      await acrAPI.getStatus();
    } catch (e: any) {
      console.log(`Error while getting status (init): ${e?.status} (${e?.statusText})`);
    }
    await this.triggerStatusTimer();
  }
  private async triggerStatusTimer(): Promise<void> {
    setTimeout(async () => {
      try {
        await acrAPI.getStatus();
      } catch (e: any) {
        console.log(`Error while getting status: ${e?.status} (${e?.statusText})`);
      }
      this.triggerStatusTimer();
    }, this.statusInterval);
  }

  private notifyLicenseStatus(license: License): void {
    let msg = "";
    let className = "";
    if (license.status === LICENSE_STATUS.WARNING) {
      className = "warning";
      msg = translate("license almost expired");
    }
    if (license.status === LICENSE_STATUS.ERROR) {
      className = "error";
      msg = translate("license invalid");
    }
    if (license.status !== LICENSE_STATUS.OK && !this.state.licenseNotif) {
      if (license.expirationDate) {
        msg += ` (${format(new Date(license.expirationDate), "yyyy/MM/dd")})`;
      }
      Store.addNotification({
        type: { className },
        container: "bottom-right",
        insert: "top",
        content: <Notification className={className} message={msg} />,
        onRemoval: () => {
          this.setState({ licenseNotif: false });
        },
      });
      this.setState({ licenseNotif: true });
    }
  }

  public render(): JSX.Element {
    return (
      <BrowserRouter>
        <AcrAppBar />
        <Box className="acrMonitorBody">
          <Routes>
            <Route path="/networkError" element={<NetworkError />} />
            <Route path="/login" element={<Login />} />
            <Route element={<PrivateRoute redirectTo="/login"/>}>
              <Route path="/logout" element={ <Logout />} />
              <Route path="/channelDetail/*" element={<ChannelDetail />} />
              <Route path="/mosaic" element={<Mosaic />} />
              <Route path="/" element={<Mosaic />} />
              <Route path="/logs" element={<SoftwareLogs />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </Box>
        <Box display="flex" justifyContent="flex-end" className="notificationContainer">
          <ReactNotifications />
        </Box>
        <Footer />
      </BrowserRouter>
    );
  }
}
